export const LIST_ROLE_MANAGEMENT = "LIST_ROLE_MANAGEMENT";
export const LIST_ROLE_MANAGEMENT_SUCCESS = "LIST_ROLE_MANAGEMENT_SUCCESS";
export const LIST_ROLE_MANAGEMENT_FAILED = "LIST_ROLE_MANAGEMENT_FAILED";
export const DELETE_ROLE_MANAGEMENT = "DELETE_ROLE_MANAGEMENT";
export const DELETE_ROLE_MANAGEMENT_SUCCESS = "DELETE_ROLE_MANAGEMENT_SUCCESS";
export const DELETE_ROLE_MANAGEMENT_FAILED = "DELETE_ROLE_MANAGEMENT_FAILED";